<template>
  <!-- Slider -->
  <div class="grid grid-cols-1">
    <Slider />
  </div>

  <section class="p-10 pb-0 2xl:px-96">
    <!-- Main Grid -->
    <div class="grid grid-cols-1 gap-4 pb-16">
      <h1 class="font-bold text-2xl uppercase pt-1 pb-0">{{ berita.judul }}</h1>
      <p class="text-gray-400">Diposting oleh: {{ berita.penulis }}</p>
      <div class="w-full">
        <img
          :src="berita.image"
          alt=""
          class="object-cover object-center h-full w-full rounded-lg"
        />
      </div>
      <p v-html="berita.isi"></p>
    </div>
  </section>

  <WhatsappButton />
</template>

<script>
//hook vue
import { computed, onMounted } from "vue";

//vuex
import { useStore } from "vuex";

// route
import { useRoute } from "vue-router";

//component slider
import Slider from "@/components/Slider.vue";

// component WhatsappButton
import WhatsappButton from "@/components/WhatsappButton.vue";

export default {
  components: {
    Slider, // <-- register component slider
    WhatsappButton,
  },

  setup() {
    //store rpute
    const route = useRoute();

    //store vuex
    const store = useStore();

    //onMounted akan menjalankan action "getCampaign" di module "campaign"
    onMounted(() => {
      store.dispatch("berita/getDetailBerita", route.params.slug);
    });

    // Storing Berita
    const berita = computed(() => {
      return store.state.berita.berita;
    });

    return {
      berita, // <-- return zakat
    };
  },
};
</script>